import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;

    > span {
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};
        margin: 10px 0;
    }

    img {
        width: 100%;
    }
`;

const PrimaryRow = styled.div`
    display: flex;

    strong {
        font-size: 11px;
        font-weight: 700;
        color: ${theme.textDark};
    }

    small {
        font-size: 11px;
        font-weight: 400;
        color: ${theme.textDark};
        margin-left: 2px;
    }
`;

export { Container, PrimaryRow };